import * as React from "react";
import { useId } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUpload = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsx("svg", {
		viewBox: "0 0 20 20",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		children: /* @__PURE__ */ _jsx("path", {
			d: "M3.33268 13.3333V14.1667C3.33268 15.5474 4.45197 16.6667 5.83268 16.6667H14.166C15.5467 16.6667 16.666 15.5474 16.666 14.1667V13.3333M9.99935 13.3333V3.33333M9.99935 3.33333L6.24935 7.08333M9.99935 3.33333L13.7493 7.08333",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	});
};
export default SvgUpload;
